(function () {
  'use strict';

  angular.module('eclipseApp.autoRegSetPassword').factory('setPasswordService', setPasswordService);

  setPasswordService.$inject = ['$q',
    '$timeout',
    '$http',
    '$window',
    'uteLocale',
    'ute.easy.login.registration.service',
    '$translate',
    '$state',
    'ute.datalayer.common.service'];

  /* @ngInject */
  function setPasswordService($q,
                              $timeout,
                              $http,
                              $window,
                              uteLocale,
                              easyLoginRegistrationService,
                              $translate,
                              $state,
                              dataLayerService) {
    var passwordToken;
    var GENESIS_URL_PREFIX = '/pages/web/genesis/api';
    var VALIDATE_TOKEN_API = GENESIS_URL_PREFIX + '/SMS/v1/token/smsLink/';
    var UPDATE_USERNAME_API = GENESIS_URL_PREFIX + '/profile-svc/v1/updateUsername';
    var RESEND_SMS_API = GENESIS_URL_PREFIX + '/SMS/v1/token/smslink';
    var UPDATE_PASSWORD_API = GENESIS_URL_PREFIX + '/user/v2/password?op=updatePassword';
    var FIDO_BRAND_QUERY_PARAM = '?brand=FIDO';
    var CONTACT_PAGE_URL = '/consumer/contact-us?setLanguage=';

    var phoneNumber = '';
    var username = '';
    var takenEmails = [];
    var dataLayerPredefinedSection = window.ute.datalayer.common.service.DataLayerPredefinedSection;
    var dataLayerErrorType = window.ute.datalayer.common.service.ErrorType;
    var dataLayerErrorCategory = window.ute.datalayer.common.service.ErrorCategory;
    var dataLayerSections = [dataLayerPredefinedSection.ACCOUNT, dataLayerPredefinedSection.PAGE, dataLayerPredefinedSection.SITE];


    function validateToken(token) {
      if (!token) {
        gotoNotFound();
        return;
      }
      passwordToken = null;
      $http.get(VALIDATE_TOKEN_API + token + FIDO_BRAND_QUERY_PARAM)
        .then(function (response) {
          if (_.has(response, 'data.content')) {
            username = response.data.content.userID;
            passwordToken = response.data.content.passwordToken;
            phoneNumber = response.data.content.phoneNumber;

            dataLayerService.track({}, false, dataLayerSections, {mappingKey: 'autoReg.setPasswordPage'});
          } else {
            $state.go('setPasswordError', {
              api: response.config.url,
              errorCode: 'SMSReg05',
              errorMessage: $translate.instant('global.label.setAutoRegistrationPassword.error.systemError')
            });
          }
        })
        .catch(function (response) {
          if (_.has(response, 'data.status.code')) {
            if (response.data.status.code === '400.001') {
              gotoNotFound();
            } else if (response.data.status.code === '400.002') {
              // display token expired
              if (_.has(response, 'data.content')) {
                phoneNumber = response.data.content.phoneNumber;
                passwordToken = response.data.content.passwordToken;
              }
              $state.go('setPasswordExpired');
            }
          } else {
            $state.go('setPasswordError', {
              api: response.config.url,
              errorCode: _.get(response, 'data.status.code') || response.status,
              errorMessage: $translate.instant('global.label.setAutoRegistrationPassword.error.systemError')
            });
          }
        });
    }


    function showModule() {
      // prevent displaying the page if token is empty or invalid
      return !!passwordToken;
    }

    function gotoContactPage() {
      $window.location.href = CONTACT_PAGE_URL + uteLocale.language;
    }

    function gotoNotFound() {
      $state.go('error404');
    }

    function getPhoneNumber() {
      return phoneNumber;
    }

    function getUsername() {
      return username;
    }

    function updateUsername(newUsername) {
      var payload = {
        oldUsername: username,
        newUsername: newUsername,
        token: passwordToken,
        brand: 'FIDO'
      };
      return $http.post(UPDATE_USERNAME_API, payload)
        .then(function (response) {
          if (_.has(response, 'data.status') && response.data.status.code === '200.000') {
            username = newUsername;
          }
          if (_.has(response, 'data.content.token')) {
            passwordToken = response.data.content.token;
          }
          dataLayerService.track({}, false, dataLayerSections, {mappingKey: 'autoReg.username.complete'});
        })
        .catch(function (response) {
          if (_.get(response, 'data.status.code') === '400.002') {
            takenEmails.push(newUsername);

            dataLayerService.trackError({},
              dataLayerErrorType.USER,
              'SMSReg01',
              $translate.instant('global.label.setAutoRegistrationPassword.error.username.taken'),
              dataLayerErrorCategory.SELF_SERVE,
              undefined,
              UPDATE_USERNAME_API,
              false,
              dataLayerSections,
              {mappingKey: 'autoReg.error'});
          } else {
            dataLayerService.trackError({},
              dataLayerErrorType.HTTP,
              _.get(response, 'data.status.code') || response.status,
              $translate.instant('global.label.setAutoRegistrationPassword.error.systemError'),
              dataLayerErrorCategory.SELF_SERVE,
              undefined,
              UPDATE_USERNAME_API,
              false,
              dataLayerSections,
              {mappingKey: 'autoReg.error'});
          }

          return $q.reject(response.data.status.code);
        });
    }

    function setPassword(password, confirmPassword) {
      return $http({
        method: 'POST',
        url: UPDATE_PASSWORD_API,
        data: {
          brand: 'FIDO',
          source: 'sms',
          newPassword: password,
          newPasswordConfirm: confirmPassword,
          token: passwordToken,
          confirmationToken: passwordToken
        },
        headers: {
          'x-app-id': 'Fido.ca'
        }
      }).then(function (response) {
        easyLoginRegistrationService.handleFidoLoginAfterSetPass(response.data);
        $state.go('setPasswordSuccess');
      }).catch(function (response) {
        dataLayerService.trackError({},
          dataLayerErrorType.HTTP,
          _.get(response, 'data.status.code') || response.status,
          $translate.instant('global.label.setAutoRegistrationPassword.error.systemError'),
          dataLayerErrorCategory.SELF_SERVE,
          undefined,
          UPDATE_PASSWORD_API,
          false,
          dataLayerSections,
          {mappingKey: 'autoReg.error'});

        return $q.reject();
      });
    }

    function resendSms() {
      return $http({
        method: 'POST',
        url: RESEND_SMS_API,
        data: {
          brand: 'FIDO',
          source: 'FRONTEND',
          token: passwordToken,
          language: 'en'
        },
        headers: {
          'x-app-id': 'Fido.ca'
        }
      }).then(function (response) {
        dataLayerService.track({}, false, dataLayerSections, {mappingKey: 'autoReg.resendSms.start'});
        return response;
      }).catch(function (response) {
        dataLayerService.trackError({},
          dataLayerErrorType.HTTP,
          _.get(response, 'data.status.code') || response.status,
          $translate.instant('global.label.setAutoRegistrationPassword.error.systemError'),
          dataLayerErrorCategory.SELF_SERVE,
          undefined,
          RESEND_SMS_API,
          false,
          dataLayerSections,
          {mappingKey: 'autoReg.resendSms.error'});

        return $q.reject();
      });
    }

    function isEmailTaken(email) {
      return _.includes(takenEmails, email);
    }

    return {
      validateToken: validateToken,
      gotoContactPage: gotoContactPage,
      getPhoneNumber: getPhoneNumber,
      getUsername: getUsername,
      updateUsername: updateUsername,
      setPassword: setPassword,
      isEmailTaken: isEmailTaken,
      resendSms: resendSms,
      showModule: showModule
    };
  }

})();
